import { Card, Typography } from '@mui/material';

export default function History() {
    return (
        <Card className="card">
            <Typography variant="h5" gutterBottom>发展历程</Typography>
            <Typography>
                2015年成立至今，我们已经完成了多个里程碑式的项目...
            </Typography>
        </Card>
    );
}
